import { gql } from "lib/apolloClient";

export const updateStudentActivityCriteriaSetsMutation = gql`
  mutation updateStudentActivityCriteriaSets(
    $input: [UpdatePointAssessmentSetInput!]
  ) {
    planner {
      updatePointAssessmentSet(input: $input) {
        warning
        response {
          id
          label
          academicCriteriaValues: categories {
            id
            label
            metadata
            displaySequence
          }
          criteriaType: type
        }
      }
    }
  }
`;

export const upsertActivityPostCommentsAsReadMutation = gql`
  mutation upsertActivityPostCommentsAsRead(
    $input: [UpsertUserEntityStateInput!]
  ) {
    platform {
      upsertUserEntityState(input: $input) {
        ... on UpsertUserEntityStateResponse {
          isSuccess
          warning
        }
      }
    }
  }
`;
